import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Panel } from '../Panel/Panel';
import { Filter } from '../../icons';
import { Message } from '../Message';
import { useStyles } from './useStyles';
import { CrewTypes } from '../../service/constants';
import { PassengerTableView } from './PassengerTableView/PassengerTableView';
import { PassengerGridView } from './PassengerGridView/PassengerGridView';

import './PassengerPage.scss';
import { useFilter, usePassengerPage } from './hooks';

export const PassengerPage = memo(() => {
    const { crewType, isMobilePortrait, passengerList, tableView, toggle } = usePassengerPage();
    const { isFilterSet, handleFilterClick } = useFilter();
    const classes = useStyles();
    const { t: translate } = useTranslation();

    return (
        <div className={classes.wrapper}>
            {crewType === CrewTypes.PCT_SALONSTAFF ? (
                <Panel
                    title={translate('labels.passengerList')}
                    className={classes.panel}
                    toggle={toggle}
                    icon={<Filter width="24" height="24" className={isFilterSet ? classes.filterIconActive : null} />}
                    onIconClick={handleFilterClick}
                >
                    {tableView ? (
                        <PassengerTableView passengerList={passengerList} isMobile={isMobilePortrait} />
                    ) : (
                        <PassengerGridView isMobile={isMobilePortrait} />
                    )}
                </Panel>
            ) : (
                <Message text={translate('messages.noAvailableInfoForLeg')} />
            )}
        </div>
    );
});

PassengerPage.displayName = 'PassengerPage';
